import { render, staticRenderFns } from "./ImportCredential.vue?vue&type=template&id=3c35d799&scoped=true"
import script from "./ImportCredential.vue?vue&type=script&lang=js"
export * from "./ImportCredential.vue?vue&type=script&lang=js"
import style0 from "./ImportCredential.vue?vue&type=style&index=0&id=3c35d799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35d799",
  null
  
)

export default component.exports